"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var usefulnessScale = ["Not at all useful", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Extremely useful"];
var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var fnUsefulnessScaleResp = function fnUsefulnessScaleResp(n) {
  return n;
};

var difficultyOptions = ["Overloaded with work", "Current project not engaging/interesting", "Lacking resources to do job", "Uncertainty if my job is secure", "Not paid enough for the work I do", "Frustrated with a colleague/colleagues", "Family issue", "Unfair/disrespectful treatment by management", "Bullying", "Not sure what's expected of me for task/role/project", "Not recognised enough for the work I do", "Lacking friendships/peer support network at work", "Lacking opportunities to work on what I like"];
var surveyscreeners = [utils.screeners.WHO5, utils.screeners.PSS4, utils.screeners.PSYCAP, utils.screeners.ROI_HPQ_4_DAYSLIDE, utils.screeners.ROI_HPQ_3_POINTSLIDE];
var questions = screenersImport.expandscreeners([{
  prompt: "This post-program assessment is similar to the one you completed at the " + "beginning of the program. It takes 5 minutes to complete, and will allow you " + "to compare your results before and after participating in Uprise. Your responses  " + "are stored securely, confidential between you and your coach, and will never be used " + "to identify you to a third party. We hope you enjoyed the program!",
  type: "multi",
  options: {
    options: [],
    reversed: false
  },
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, {
  prompt: "We hope you enjoyed the program! Could you write us a short testimonial that we can share with others? (we promise not to identify you unless you say it's ok)",
  type: "single",
  optional: true,
  key: "testimonial",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}].concat(surveyscreeners, [// NPS
{
  prompt: "How likely are you to recommend your company to a friend as a " + "great place to work?",
  extraText: "",
  type: "slider",
  options: likelihood,
  key: "npsWork",
  eval: likelihoodFn,
  batteryId: "survey"
}, // Company support and cohesion
{
  prompt: "In the past week, to what extent have you felt supported by " + "your company?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "companySupport",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, {
  prompt: "In the past week, to what extent have you felt supported by " + "your manager?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "managerSupport",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, {
  prompt: "In the past week, how united has your team been in trying to " + "reach its goals for performance?",
  extraText: "",
  type: "slider",
  options: ["Not at all united", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely united"],
  key: "cohesion",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, // Sleep
{
  prompt: "Please rate the quality of your sleep over the last week.",
  extraText: "",
  type: "slider",
  options: ["Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Best possible sleep"],
  key: "sleepQuality",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, {
  prompt: "How many visits with any healthcare professional have you had in the last month (under public or private health cover)?",
  extraText: "",
  key: "healthCare",
  eval: function _eval(n) {
    return n;
  },
  type: "single",
  optional: true
}, // Difficulties
{
  prompt: "Are any of the following making it hard for you to work " + "effectively right now? (You may need to scroll down to see the 'Next/Done' button.)",
  extraText: "",
  type: "multiselect",
  batteryId: "survey",
  options: difficultyOptions,
  optional: true,
  key: "difficulties",
  eval: function _eval(answer, question) {
    if (answer === "No response given" || answer === undefined) {
      return answer;
    } else {
      return answer.map(function (i) {
        return question.options[parseInt(i)];
      }).join(", ");
    }
  }
}, // NPS - Uprise
{
  prompt: "How likely would you be to recommend the Uprise program to a " + "colleague or friend?",
  extraText: "",
  type: "slider",
  batteryId: "survey",
  options: likelihood,
  key: "npsUprise",
  eval: likelihoodFn
}, {
  prompt: "Were you considering leaving your company but changed your mind " + "as a result of getting support via Uprise? (Reminder: all your " + "answers are confidential. This question helps us to demonstrate " + "reduction in turnover to your company)",
  extraText: "",
  type: "multi",
  options: ["Yes", "No", "N/A"],
  optional: false,
  key: "TurnoverRisk",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, // Program evaluation, phrased in a way to encourage reflection
{
  prompt: "How would you rate module 1 (retraining thoughts)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod1_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 2 (work-life balance)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod2_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 3 (mindfulness)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod3_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 4 (stress management)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod4_SM_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How useful did you find the coaching calls?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  batteryId: "survey"
}, // Feedback and Referral
{
  prompt: "If you had a magic wand and could change one thing about the " + "program, what would it be?",
  extraText: "",
  type: "single",
  optional: true,
  key: "magicWand",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "Would you be willing to give some brief feedback via the phone " + "following the completion of the program?",
  extraText: "",
  type: "multi",
  key: "feedback",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey",
  options: ["Yes", "No"]
}, {
  prompt: "Please leave the email addresses of anyone in your " + "company you would like to offer Uprise to (we won't mention " + "your name, you will be kept anonymous)",
  extraText: "",
  type: "single",
  optional: true,
  key: "referral",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}]));

var analysis = function analysis(answers) {
  if (!answers) return null;
  var results = {};
  results.humanReadable = {};

  if (questions.length > answers.length) {
    answers.splice(25, 0, "N/A");
  }

  surveyscreeners.forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[i], q);
    results.humanReadable[q.prompt] = q.eval(answers[i], q);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};